import React, { useContext } from 'react';
import { Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { RoadPavement } from '../../../../../../../services/types/Calculator';
import CalculatorSectorContext from '../../UrbanInfrastructureTool/CalculatorSectorContext';
import NumberFormatterSinSeparador from '../../../NumberFormatterSinSeparador';

interface RoadPavementDetailsBaseProps {
  roadPavement: RoadPavement;
  calculateFactorTotalArea: (roadPavement: RoadPavement, measurementSystemId: number) => number;
  calculateFactorValue: (roadPavement: RoadPavement, measurementSystemId: number) => number;
}

const RoadPavementDetailsBase: React.FC<RoadPavementDetailsBaseProps> = ({
  roadPavement,
  calculateFactorTotalArea,
  calculateFactorValue,
}) => {
  const { t } = useTranslation();
  const { measurementSystem } = useContext(CalculatorSectorContext);

  const getTextMeasure = (): string =>
    measurementSystem.id === 2 && roadPavement.isTotalAreaKnown
      ? '(t CO<sub>2</sub>/1000 sq foot)'
      : '(t CO<sub>2</sub>/ 1000 sq meters)';

  const factorTotalArea = calculateFactorTotalArea(roadPavement, measurementSystem.id);
  const factorValue = calculateFactorValue(roadPavement, measurementSystem.id);

  return (
    <div className="table-wrapper">
      <Table
        responsive
        className="table--bordered calculator table-details"
        style={{ tableLayout: 'fixed' }}
      >
        <colgroup>
          <col style={{ width: '50%' }} />
          <col style={{ width: '50%' }} />
        </colgroup>
        <thead>
          <tr>
            <th>{parse(t('Default Emission Factor ') + getTextMeasure())}</th>
            <th>{parse(t('CO<sub>2</sub> Emissions (t CO<sub>2</sub>)'))}</th>
          </tr>
        </thead>
        <tbody>
          {roadPavement.subTotal && factorValue && (
            <tr>
              <td>
                <NumberFormatterSinSeparador
                  value={roadPavement.isTotalAreaKnown ? factorTotalArea : factorValue}
                />
              </td>
              <td>
                <NumberFormatterSinSeparador value={roadPavement.subTotal} />
              </td>
            </tr>
          )}
        </tbody>
        <tfoot>
          <tr>
            {/* espaciador intencional, sin contenido */}
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <td colSpan={2} />
          </tr>
        </tfoot>
      </Table>
    </div>
  );
};

export default RoadPavementDetailsBase;
